export interface CategoryDTO {
  id: number;
  name: { [locale: string]: string };
  supplierCategories: string[] | null;
  children?: CategoryDTO[];
}

export class Category {
  private _id: number = 0;
  private _name: string = "";
  private _supplierCategories: string = "";
  private _children: Category[] = [];
  private _parent: Category | null = null;

  static create(dto: CategoryDTO, parent: Category | null = null): Category {
    const instance = new Category();

    instance._id = dto.id;
    instance._name = dto.name.pl;
    instance._supplierCategories = dto.supplierCategories
      ? dto.supplierCategories.join(", ")
      : "";
    instance._parent = parent;

    if (dto.children && dto.children.length > 0) {
      instance._children = dto.children.map(childDto =>
        Category.create(childDto, instance)
      );
    }

    return instance;
  }

  get id(): number {
    return this._id;
  }

  get name(): string {
    return this._parent ? this._parent._name : this._name;
  }

  get ownName(): string {
    return this._name;
  }

  get subcategory(): string {
    return this._parent ? this._name : "";
  }

  get supplierCategories(): string {
    return this._supplierCategories;
  }

  get children(): Category[] {
    return this._children;
  }

  get parent(): Category | null {
    return this._parent;
  }
}
